import { createFileRoute } from "@tanstack/react-router";
import WorkspaceHomePage from "@/features/workspaces/workspace-home.page";

export const Route = createFileRoute("/_authenticated/workspaces/$slug/")({
  component: WorkspaceHomePage,
});
